@if (project | async; as project) {
  <app-comment-section
    class="w-full"
    [parentEntity]="project"
    parentEntityType="project"
  ></app-comment-section>
}
